const WebSectionRoutes = {
  getWebSection: 'getWebsiteSections',
};

export default WebSectionRoutes